import classNames from 'classnames'

const CloseButton = ({
  onClick,
  type,
}) => {
  const className = classNames('btn-close p-3 text-primary rounded-full', {
    [`btn-close--${type}`]: type
  });

  return (
    <button className={className} onClick={onClick}>
      <i className="ri-close-line" />
    </button>
  )
}

export default CloseButton
